<template>
  <el-carousel class="box"  type="card" >
    <el-carousel-item v-for="item in productsList" :key="item.ID">
      <!-- <h3 class="medium">{{ item.Title }}</h3> -->
      <div class="CNewItem"  >
        <p class="CNewItemImg"><img src="../../index/ccjc.png" alt=""></p>
        <p class="CNewItemTitle">{{item.Title}}</p>
        <p class="CNewItemText">{{item.Info}}</p>
        <p class="CNewItemBtn">了解详情</p>
      </div>
    </el-carousel-item>
  </el-carousel>
</template>
<script>
export default {
  props: ['productsList']
}
</script>

<style lang="scss" scoped>
$md:72/192*2;
.box{
  margin-top: 30px/$md;
  width: 100%;
  height: 700px/$md;
}
 ::v-deep .el-carousel__container{
  height: 700px/$md !important;
}
//  ::v-deep .el-carousel{
//   height: 700px/$md;
// }
// ::v-deep .box .el-carousel .el-carousel--horizontal .el-carousel--card{
//   height: 700px/$md;;
// }
.CNewItem{
  width: 360px/$md;
  height: 555px/$md;
  background: #FFFFFF;
  border: 1px solid #FAFAFB;
  box-shadow: 0px 4px/$md 8px/$md rgba(0,0,0,0.08);
  border-radius: 4px/$md;
  overflow: hidden;
  .CNewItemImg{
  width: 60px/$md;
  height: 60px/$md;
     margin: auto;
     margin-top: 47px/$md;
     margin-bottom: 30px/$md;
    img{
     width: 100%;
     height: 100%;
   }
  }
  .CNewItemTitle{
    width: 100%;
    height: 45px/$md;
    font-size: 32px/$md;
    font-weight: 500;
    line-height: 45px/$md;
    color: #000000;
    text-align: center;
    margin-bottom: 30px/$md;
  }
  .CNewItemText{
    width: 267px/$md;
height: 237px/$md;
font-size: 24px/$md;
font-weight: 400;
line-height: 34px/$md;
color: #666666;
margin: auto;
  }
  .CNewItemBtn{
    width: 148px/$md;
height: 44px/$md;
background: #2380E1;
border-radius: 6px/$md;
color: #FFFFFF;
margin: auto;
margin-top: 30px/$md;
text-align: center;
line-height: 44px/$md;
  }
}
// $sun:100/192;
// .box{
//     width: 1100px;
//     height: 460px;
// }
// .el-carousel__item, .el-carousel__mask{
//     width: 330px;height: 460px;margin-left: 100px;
// }
//  ::v-deep .el-carousel__container{
//     height: 500px !important;
//     overflow: hidden !important;
// }
//  ::v-deep.el-carousel__indicators--outside{
//     display: none !important;
// }
//   ::v-deep.el-carousel__indicators{
//     display: none!important;
// }
//   .el-carousel__item h3 {
//     // color: #475669;
//     font-size: 14px;
//     opacity: 0.75;
//     line-height: 200px;
//     margin: 0;
//   }
  // .CNewItem{
  //   width: 320px*$sun;
  //   height: 460px*$sun;
  //   background: #FFFFFF;
  //   display: flex;
  //   flex-direction: column;
  //   justify-content: space-between;
  //   align-items: center;
  //   overflow: hidden;
  //   padding-top: 26px*$sun;
  //   padding-bottom: 36px*$sun;
  //   box-sizing: border-box;
  //   // transition: ease 1s;
  //   transition:all 1s;
  //   .CNewItemImg{
  //       width: 46px*$sun;
  //       height: 46px*$sun;
  //       margin: 0 auto;
  //       img{
  //           width: 100%;
  //           height: 100%;
  //       }
  //   }
  //   .CNewItemTitle{
  //       width: 100%;
  //       height: 30px*$sun;
  //       font-size: 22px*$sun;
  //       text-align: center;
  //       // margin: 0 auto;
  //   }
  //   .CNewItemText{
  //       width: 244px*$sun;
  //       height: 220px*$sun;
  //       font-size: 14px*$sun;
  //       color: #666666;
  //       line-height: 28px*$sun;
  //       display: -webkit-box;
  //       -webkit-box-orient: vertical;
  //       -webkit-line-clamp: 8; /* 显示三行，后面省略 */
  //       overflow: hidden;
  //       margin: 0 auto;
  //   }
  //   .CNewItemBtn{
  //       min-width: 106px*$sun;
  //       width: 106px*$sun;
  //       height: 31px*$sun;
  //       font-size: 14px*$sun;
  //       text-align: center;
  //       background: #2380E1;
  //       color: #FFFFFF;
  //       border-radius: 6px*$sun;
  //       display: flex;
  //       justify-content: center;
  //       align-items: center;
  //       margin: 0 auto;
  //   }

  // }
</style>
